/*
 * @Description: 工具集合
 * @Date: 2019-09-17 10:55:01
 */
import { Message } from 'element-ui';
import { MessageBox } from 'element-ui';
import axios from 'axios';

/**
 * @description: 简易拷贝
 * @param {object} target
 * @return: object
 */
export const easyCopy = target => {
  return JSON.parse(JSON.stringify(target));
};
/**
 * @description: 深拷贝
 * @param {object} target
 * @return: object
 */
export const deepClone = target => {
  let result;
  if (typeof target === 'object') {
    if (Array.isArray(target)) {
      result = [];
      for (let i in target) {
        result.push(deepClone(target[i]));
      }
    } else if (target === null) {
      result = null;
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
  } else {
    result = target;
  }
  return result;
};
/**
 * @description: 获取类型
 * @param {type} field 传入需要判断的字段
 * @return: {string}  [object Number] [object String] [object Number]
 *                    [object Function] [object Array] [object Undefined]
 *                    [object Boolean] [object Null]
 */
export const getTypeToString = field => {
  return Object.prototype.toString.call(field);
};

/**
 * @description: 获取百分比
 * @param {number,number,object}
 * @return: string|number
 */
export const percentage = (dividend = 0, divisor = 100, options = {}) => {
  let args = { digit: 2, multiple: 100, symbol: '%', ...options };
  let res = ((dividend / divisor) * args.multiple).toFixed(args.digit);
  let p = isNaN(res) ? 0 : res;
  return p;
};
/**
 * @description: 确认操作，需要兼容之前mixin
 * @param {function，object，string} 回调，当前数据， 提示
 * @return: void
 */
export const makeSure = (cb = null, row = null, text = '是否确定操作？') => {
  MessageBox.confirm(text)
    .then(() => {
      if (cb) {
        cb(row);
      } else {
        done();
        console.error('确认事件缺少回调');
      }
    })
    .catch(() => {
      Message('取消操作');
    });
};
// base64转换为blob流
export const dataURLToBlob = dataurl => {
  let arr = dataurl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};
// blob流转换为base64
export const blobToDataURI = blob => {
  return new Promise(resolve => {
    let reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = e => {
      resolve(e.target.result);
    };
  });
};
export const getNetFile = async (url, responseType = 'blob', options = {data:{noInterceptor:true}}) => {
  let { data } = await axios.get(url, {
    responseType,
    ...options
  });
  return data
};
export const image2Base64 = (img) => {
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0, img.width, img.height);
  let dataURL = canvas.toDataURL('image/png');
  return dataURL;
};
export const getImgBase64 = (src) => {
  return new Promise(resolve => {
    let base64 = '';
    let img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.src = src;
    img.onload = () => {
      base64 = image2Base64(img);
      resolve(base64);
    };
  });
}